$(document).ready(function() {
    console.log('🔍 Verificando carga de datos de archivos Liquid...');
    console.log('==========================================');
    
    // Verificar datos de Midea MX
    if (typeof window.mideaMxProductData !== 'undefined') {
        console.log('✅ mideaMxProductData cargado correctamente');
        console.log('📊 Número de URLs de productos:', window.mideaMxProductData.length);
    } else {
        console.error('❌ mideaMxProductData no está disponible');
    }
    
    if (typeof window.mideaMxPageData !== 'undefined') {
        console.log('✅ mideaMxPageData cargado correctamente');
        console.log('📊 Número de URLs de páginas:', window.mideaMxPageData.length);
    } else {
        console.error('❌ mideaMxPageData no está disponible');
    }
    
    if (typeof window.mideaMxBlogData !== 'undefined') {
        console.log('✅ mideaMxBlogData cargado correctamente');
        console.log('📊 Número de URLs de blog:', window.mideaMxBlogData.length);
    } else {
        console.error('❌ mideaMxBlogData no está disponible');
    }
    
    if (typeof window.mideaMxCollectionData !== 'undefined') {
        console.log('✅ mideaMxCollectionData cargado correctamente');
        console.log('📊 Número de URLs de colecciones:', window.mideaMxCollectionData.length);
    } else {
        console.error('❌ mideaMxCollectionData no está disponible');
    }
    
    // Verificar datos de Index
    if (typeof window.indexProductData !== 'undefined') {
        console.log('✅ indexProductData cargado correctamente');
        console.log('📊 Número de URLs de productos (index):', window.indexProductData.length);
    } else {
        console.error('❌ indexProductData no está disponible');
    }
    
    if (typeof window.indexPageData !== 'undefined') {
        console.log('✅ indexPageData cargado correctamente');
        console.log('📊 Número de URLs de páginas (index):', window.indexPageData.length);
    } else {
        console.error('❌ indexPageData no está disponible');
    }
    
    if (typeof window.indexBlogData !== 'undefined') {
        console.log('✅ indexBlogData cargado correctamente');
        console.log('📊 Número de URLs de blog (index):', window.indexBlogData.length);
    } else {
        console.error('❌ indexBlogData no está disponible');
    }
    
    if (typeof window.indexCollectionData !== 'undefined') {
        console.log('✅ indexCollectionData cargado correctamente');
        console.log('📊 Número de URLs de colecciones (index):', window.indexCollectionData.length);
    } else {
        console.error('❌ indexCollectionData no está disponible');
    }
    
    console.log('==========================================');
    console.log('🎯 Verificación completada');
    
    // Mostrar total de URLs cargadas
    var totalUrls = 0;
    var objetosCargados = 0;
    
    if (typeof window.mideaMxProductData !== 'undefined') {
        totalUrls += window.mideaMxProductData.length;
        objetosCargados++;
    }
    if (typeof window.mideaMxPageData !== 'undefined') {
        totalUrls += window.mideaMxPageData.length;
        objetosCargados++;
    }
    if (typeof window.mideaMxBlogData !== 'undefined') {
        totalUrls += window.mideaMxBlogData.length;
        objetosCargados++;
    }
    if (typeof window.mideaMxCollectionData !== 'undefined') {
        totalUrls += window.mideaMxCollectionData.length;
        objetosCargados++;
    }
    if (typeof window.indexProductData !== 'undefined') {
        totalUrls += window.indexProductData.length;
        objetosCargados++;
    }
    if (typeof window.indexPageData !== 'undefined') {
        totalUrls += window.indexPageData.length;
        objetosCargados++;
    }
    if (typeof window.indexBlogData !== 'undefined') {
        totalUrls += window.indexBlogData.length;
        objetosCargados++;
    }
    if (typeof window.indexCollectionData !== 'undefined') {
        totalUrls += window.indexCollectionData.length;
        objetosCargados++;
    }
    
    console.log('📈 Resumen:');
    console.log('   - Objetos cargados:', objetosCargados + '/8');
    console.log('   - Total de URLs:', totalUrls);
    
    // Función para encontrar URLs similares
    function encontrarURLsSimilares() {
        console.log('🔍 Buscando URLs similares entre sitios...');
        console.log('==========================================');
        
        var coincidencias = [];
        var currentPath = window.location.pathname;
        
        // Determinar qué tipo de comparación hacer basado en el path actual
        var tipoComparacion = '';
        var datosIndex = null;
        var datosMx = null;
        
        if (currentPath.startsWith('/pages/')) {
            tipoComparacion = 'Página';
            datosIndex = window.indexPageData;
            datosMx = window.mideaMxPageData;
            console.log('📄 Detectado: Comparando solo páginas');
        } else if (currentPath.startsWith('/collections/')) {
            tipoComparacion = 'Colección';
            datosIndex = window.indexCollectionData;
            datosMx = window.mideaMxCollectionData;
            console.log('📚 Detectado: Comparando solo colecciones');
        } else if (currentPath.startsWith('/blogs/') || currentPath.startsWith('/blog/')) {
            tipoComparacion = 'Blog';
            datosIndex = window.indexBlogData;
            datosMx = window.mideaMxBlogData;
            console.log('📝 Detectado: Comparando solo blog');
        } else if (currentPath.startsWith('/products/')) {
            tipoComparacion = 'Producto';
            datosIndex = window.indexProductData;
            datosMx = window.mideaMxProductData;
            console.log('🛍️ Detectado: Comparando solo productos');
        } else if (currentPath === '/' || currentPath === '') {
            tipoComparacion = 'Index (Principal)';
            console.log('🏠 Detectado: Página principal');
        } else {
            // Si no coincide con ningún patrón, hacer comparación completa
            tipoComparacion = 'General';
            console.log('🔍 Detectado: Comparación general (path no reconocido)');
        }
        
        // Comparación por defecto - URLs principales (siempre incluida)
        console.log('🏠 Comparación de index (URLs principales):');
        console.log('   🏪 Index: https://mx-shop.midea.com/');
        console.log('   🌐 MX:    https://www.midea.com/mx');
        console.log('');
        
        // Agregar la comparación por defecto a las coincidencias
        coincidencias.push({
            tipo: 'Index (Principal)',
            index: 'https://mx-shop.midea.com/',
            mx: 'https://www.midea.com/mx'
        });
        
        // Si es página principal, solo hacer la comparación por defecto
        if (tipoComparacion === 'Index (Principal)') {
            console.log('✅ Solo comparación principal necesaria');
            return coincidencias;
        }
        
        // Mapeo de palabras clave para identificar similitudes
        var mapeoSimilitudes = {
            // Páginas principales
            'about-us': 'sobre-midea',
            'about': 'sobre-midea',
            'nosotros': 'sobre-midea',
            'contacto': 'contacto',
            'contact': 'contacto',
            'faq': 'faq',
            'preguntas-frecuentes': 'faq',
            'terminos': 'terminos-de-uso',
            'terminos-y-condiciones': 'terminos-de-uso',
            'privacidad': 'aviso-de-privacidad',
            'aviso-de-privacidad': 'aviso-de-privacidad',
            'garantia': 'satisfaccion-garantizada',
            'satisfaccion-y-garantia': 'satisfaccion-garantizada',
            'satisfaccion-garantizada': 'satisfaccion-garantizada',
            
            // Categorías de productos
            'aire-acondicionado': 'aire-acondicionado',
            'refrigeracion': 'refrigeracion',
            'lavanderia': 'lavanderia',
            'cocina': 'coccion',
            'microondas': 'microondas',
            'congeladores': 'congeladores',
            'lavavajillas': 'lavavajillas',
            'enseres-menores': 'enseres-menores',
            'tratamiento-del-aire': 'tratamiento-del-aire',
            'comercial': 'comercial',
            
            // Subcategorías específicas
            'minisplits': 'aire-acondicionado/minisplit',
            'ventana': 'aire-acondicionado/ventana',
            'portatiles': 'aire-acondicionado/portatil',
            'refrigeradores': 'refrigeracion',
            'frigobares': 'refrigeracion/frigobares',
            'lavadoras': 'lavanderia/lavadoras',
            'lavasecadora': 'lavanderia/lavasecadoras',
            'estufas': 'coccion/estufas',
            'parrillas': 'coccion/parrillas',
            'campanas': 'coccion/campanas',
            'horno': 'coccion/horno',
            'freidora-de-aire': 'enseres-menores/freidora-de-aire',
            'ventiladores': 'tratamiento-del-aire/ventilador',
            'purificadores-de-aire': 'tratamiento-del-aire/purificador-de-aire',
            'deshumidificadores': 'tratamiento-del-aire/deshumidificador',
            'calefactores': 'tratamiento-del-aire/calentadores',
            'enfriadores-de-aire': 'tratamiento-del-aire/enfriador-de-aire',
            
            // Blog
            'blog': 'blog',
            'blogs': 'blog',
            'noticias': 'blog/ver-todas/noticias',
            'recetas': 'blog/ver-todas/recetas',
            'tips': 'blog/ver-todas/tips'
        };
        
        // Función para extraer la parte relevante de la URL
        function extraerClave(url) {
            try {
                var urlObj = new URL(url);
                var path = urlObj.pathname;
                
                // Remover barras iniciales y finales
                path = path.replace(/^\/+|\/+$/g, '');
                
                // Extraer la última parte de la URL (después de la última barra)
                var partes = path.split('/');
                var ultimaParte = partes[partes.length - 1];
                
                // Si la última parte está vacía, tomar la penúltima
                if (!ultimaParte && partes.length > 1) {
                    ultimaParte = partes[partes.length - 2];
                }
                
                return ultimaParte.toLowerCase();
            } catch (e) {
                return '';
            }
        }
        
        // Función para encontrar similitud
        function encontrarSimilitud(urlIndex, urlMx) {
            var claveIndex = extraerClave(urlIndex);
            var claveMx = extraerClave(urlMx);
            
            // Verificar mapeo directo
            if (mapeoSimilitudes[claveIndex] === claveMx) {
                return true;
            }
            
            // Verificar similitud por palabras clave
            for (var clave in mapeoSimilitudes) {
                if (claveIndex.includes(clave) && claveMx.includes(mapeoSimilitudes[clave])) {
                    return true;
                }
            }
            
            // Verificar similitud por contenido de URL
            var palabrasIndex = claveIndex.split('-');
            var palabrasMx = claveMx.split('-');
            
            var coincidencias = 0;
            for (var i = 0; i < palabrasIndex.length; i++) {
                for (var j = 0; j < palabrasMx.length; j++) {
                    if (palabrasIndex[i] === palabrasMx[j] && palabrasIndex[i].length > 2) {
                        coincidencias++;
                    }
                }
            }
            
            // Si hay al menos 2 palabras coincidentes, considerar similar
            return coincidencias >= 2;
        }
        
        // Comparar solo los datos relevantes según el tipo
        if (datosIndex && datosMx) {
            console.log(`📊 Comparando ${tipoComparacion.toLowerCase()}s...`);
            console.log(`   🏪 URLs Index: ${datosIndex.length}`);
            console.log(`   🌐 URLs MX: ${datosMx.length}`);
            
            for (var i = 0; i < datosIndex.length; i++) {
                for (var j = 0; j < datosMx.length; j++) {
                    if (encontrarSimilitud(datosIndex[i], datosMx[j])) {
                        coincidencias.push({
                            tipo: tipoComparacion,
                            index: datosIndex[i],
                            mx: datosMx[j]
                        });
                    }
                }
            }
            
            console.log(`   ✅ ${tipoComparacion}s coincidentes encontrados: ${coincidencias.length - 1}`); // -1 por la comparación por defecto
        } else if (tipoComparacion === 'General') {
            // Si es comparación general, hacer todas las comparaciones
            console.log('🔍 Comparación general - verificando todos los tipos...');
            
            // Comparar URLs de páginas
            if (window.indexPageData && window.mideaMxPageData) {
                console.log('📄 Comparando páginas...');
                for (var i = 0; i < window.indexPageData.length; i++) {
                    for (var j = 0; j < window.mideaMxPageData.length; j++) {
                        if (encontrarSimilitud(window.indexPageData[i], window.mideaMxPageData[j])) {
                            coincidencias.push({
                                tipo: 'Página',
                                index: window.indexPageData[i],
                                mx: window.mideaMxPageData[j]
                            });
                        }
                    }
                }
            }
            
            // Comparar URLs de blog
            if (window.indexBlogData && window.mideaMxBlogData) {
                console.log('📝 Comparando blog...');
                for (var i = 0; i < window.indexBlogData.length; i++) {
                    for (var j = 0; j < window.mideaMxBlogData.length; j++) {
                        if (encontrarSimilitud(window.indexBlogData[i], window.mideaMxBlogData[j])) {
                            coincidencias.push({
                                tipo: 'Blog',
                                index: window.indexBlogData[i],
                                mx: window.mideaMxBlogData[j]
                            });
                        }
                    }
                }
            }
            
            // Comparar URLs de colecciones
            if (window.indexCollectionData && window.mideaMxCollectionData) {
                console.log('📚 Comparando colecciones...');
                for (var i = 0; i < window.indexCollectionData.length; i++) {
                    for (var j = 0; j < window.mideaMxCollectionData.length; j++) {
                        if (encontrarSimilitud(window.indexCollectionData[i], window.mideaMxCollectionData[j])) {
                            coincidencias.push({
                                tipo: 'Colección',
                                index: window.indexCollectionData[i],
                                mx: window.mideaMxCollectionData[j]
                            });
                        }
                    }
                }
            }
            
            // Comparar URLs de productos
            if (window.indexProductData && window.mideaMxProductData) {
                console.log('🛍️ Comparando productos...');
                var productosCoincidentes = 0;
                for (var i = 0; i < window.indexProductData.length; i++) {
                    for (var j = 0; j < window.mideaMxProductData.length; j++) {
                        if (encontrarSimilitud(window.indexProductData[i], window.mideaMxProductData[j])) {
                            coincidencias.push({
                                tipo: 'Producto',
                                index: window.indexProductData[i],
                                mx: window.mideaMxProductData[j]
                            });
                            productosCoincidentes++;
                        }
                    }
                }
                console.log(`   📦 Productos coincidentes encontrados: ${productosCoincidentes}`);
            }
        }
        
        // Mostrar resultados
        console.log('🎯 URLs similares encontradas:', coincidencias.length);
        console.log('==========================================');
        
        if (coincidencias.length > 0) {
            coincidencias.forEach(function(coincidencia, index) {
                console.log(`${index + 1}. ${coincidencia.tipo}:`);
                console.log(`   🏪 Index: ${coincidencia.index}`);
                console.log(`   🌐 MX:    ${coincidencia.mx}`);
                console.log('');
            });
        } else {
            console.log('❌ No se encontraron URLs similares');
        }
        
        console.log('==========================================');
        
        // Retornar las coincidencias para usarlas en hacerRedirects
        return coincidencias;
    }
    
    // Función para hacer redirects basados en similitudes
    function hacerRedirects(coincidencias) {
        console.log('🔄 Iniciando sistema de redirects...');
        console.log('==========================================');
        
        var currentUrl = window.location.href;
        var currentPath = window.location.pathname;
        
        console.log('📍 URL actual:', currentUrl);
        console.log('📍 Path actual:', currentPath);
        
        // Verificar si estamos en páginas que NO deben tener redirect
        if (currentPath.startsWith('/checkout') || 
            currentPath.startsWith('/pages/facturacion') || 
            currentPath.startsWith('/pages/sitetest')) {
            console.log('🚫 Página excluida de redirects (checkout/facturación/sitetest)');
            console.log('==========================================');
            return;
        }
        
        // Buscar coincidencia para la URL actual
        var urlEncontrada = null;
        var tipoCoincidencia = '';
        
        for (var i = 0; i < coincidencias.length; i++) {
            var coincidencia = coincidencias[i];
            
            // Comparar la URL actual con las URLs del index
            if (coincidencia.index === currentUrl || 
                coincidencia.index.replace(/\/$/, '') === currentUrl.replace(/\/$/, '')) {
                urlEncontrada = coincidencia.mx;
                tipoCoincidencia = coincidencia.tipo;
                break;
            }
            
            // También verificar si el path coincide
            var pathIndex = new URL(coincidencia.index).pathname;
            if (pathIndex === currentPath || 
                pathIndex.replace(/\/$/, '') === currentPath.replace(/\/$/, '')) {
                urlEncontrada = coincidencia.mx;
                tipoCoincidencia = coincidencia.tipo;
                break;
            }
        }
        
        if (urlEncontrada) {
            console.log('✅ Coincidencia encontrada:');
            console.log(`   📍 Tipo: ${tipoCoincidencia}`);
            console.log(`   🏪 Desde: ${currentUrl}`);
            console.log(`   🌐 Hacia: ${urlEncontrada}`);
            console.log('🔄 Redirigiendo inmediatamente...');
            console.log('==========================================');
            
            // Redirect inmediato
            window.location.href = urlEncontrada;
            
        } else {
            console.log('❌ No se encontró coincidencia para la URL actual');
            // Si es blog, redirigir al blog principal
            if (currentPath.startsWith('/blogs/') || currentPath.startsWith('/blog/')) {
                console.log('💡 Redirigiendo al blog principal del nuevo sitio web');
                window.location.href = 'https://www.midea.com/mx/blog/';
            } else if (currentPath.startsWith('/collections/')) {
                // Lógica de fallback para colecciones
                var coleccionShopify = currentPath.split('/')[2]; // minisplits, etc.
                var coincidenciaColeccion = null;
                // Función para normalizar nombres (minúsculas, sin guiones, sin s final)
                function normalizarNombre(nombre) {
                    nombre = nombre.toLowerCase().replace(/[-_]/g, '');
                    if (nombre.endsWith('s')) {
                        nombre = nombre.slice(0, -1);
                    }
                    return nombre;
                }
                var coleccionShopifyNorm = normalizarNombre(coleccionShopify);
                // Buscar coincidencia exacta (inteligente)
                if (window.mideaMxCollectionData) {
                    for (var i = 0; i < window.mideaMxCollectionData.length; i++) {
                        var urlColeccion = window.mideaMxCollectionData[i];
                        var partesUrl = urlColeccion.split('/');
                        var ultimaParte = partesUrl[partesUrl.length - 1] || partesUrl[partesUrl.length - 2];
                        var ultimaParteNorm = normalizarNombre(ultimaParte);
                        if (coleccionShopifyNorm === ultimaParteNorm) {
                            coincidenciaColeccion = urlColeccion;
                            break;
                        }
                    }
                    // Si no hay coincidencia exacta, buscar coincidencia de segundo nivel (inteligente)
                    if (!coincidenciaColeccion) {
                        for (var i = 0; i < window.mideaMxCollectionData.length; i++) {
                            var urlColeccion = window.mideaMxCollectionData[i];
                            // Extraer el segundo parámetro de la URL de midea
                            var partes = urlColeccion.replace('https://www.midea.com/mx/', '').split('/');
                            if (partes.length > 1) {
                                var categoriaPadre = normalizarNombre(partes[0]);
                                if (coleccionShopifyNorm.includes(categoriaPadre) || categoriaPadre.includes(coleccionShopifyNorm)) {
                                    coincidenciaColeccion = 'https://www.midea.com/mx/' + partes[0] + '/';
                                    break;
                                }
                            }
                        }
                    }
                }
                if (coincidenciaColeccion) {
                    console.log('💡 Redirigiendo a la colección relacionada del nuevo sitio web:', coincidenciaColeccion);
                    window.location.href = coincidenciaColeccion;
                } else {
                    console.log('💡 Redirigiendo al homepage del nuevo sitio web');
                    window.location.href = 'https://www.midea.com/mx';
                }
                console.log('==========================================');
            } else if (currentPath.startsWith('/products/')) {
                // Lógica de coincidencia inteligente para productos
                var productoShopify = currentPath.split('/')[2];
                var coincidenciaProducto = null;
                function normalizarNombre(nombre) {
                    nombre = nombre.toLowerCase().replace(/[-_]/g, '');
                    if (nombre.endsWith('s')) {
                        nombre = nombre.slice(0, -1);
                    }
                    return nombre;
                }
                var productoShopifyNorm = normalizarNombre(productoShopify);
                if (window.mideaMxProductData) {
                    for (var i = 0; i < window.mideaMxProductData.length; i++) {
                        var urlProducto = window.mideaMxProductData[i];
                        var partesUrl = urlProducto.split('/');
                        var ultimaParte = partesUrl[partesUrl.length - 1] || partesUrl[partesUrl.length - 2];
                        var ultimaParteNorm = normalizarNombre(ultimaParte);
                        if (productoShopifyNorm === ultimaParteNorm) {
                            coincidenciaProducto = urlProducto;
                            break;
                        }
                    }
                }
                if (coincidenciaProducto) {
                    console.log('💡 Redirigiendo al producto relacionado del nuevo sitio web:', coincidenciaProducto);
                    window.location.href = coincidenciaProducto;
                } else {
                    console.log('💡 Redirigiendo al homepage del nuevo sitio web');
                    window.location.href = 'https://www.midea.com/mx';
                }
                console.log('==========================================');
            } else {
                console.log('💡 Redirigiendo al homepage del nuevo sitio web');
                window.location.href = 'https://www.midea.com/mx';
                console.log('==========================================');
            }
        }
    }
    
    // Ejecutar búsqueda de similitudes y redirects prácticamente instantáneo
    setTimeout(function() {
        var coincidencias = encontrarURLsSimilares();
        // Ejecutar redirects inmediatamente
        hacerRedirects(coincidencias);
    }, 10);
});